import script from "./FarmClubDealsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./FarmClubDealsView.vue?vue&type=script&lang=ts&setup=true"

import "./FarmClubDealsView.vue?vue&type=style&index=0&id=6edcdcb2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6edcdcb2"]])

export default __exports__